import type {StaticImageData} from 'next/image'

import applyGraduation2 from '@/public/images/apply-graduation-2.jpg'

/**
 * The photo and caption on the application's sign-in, returning-applicant and
 * submitted screens. graduation-2 won the application-page hero-image A/B test
 * and is now the only hero; the experiment and its flag are retired.
 */
export const APPLICATION_HERO: {
  readonly image: StaticImageData
  readonly graduateName: string
} = {
  image: applyGraduation2,
  graduateName: 'Josephine L.',
}
